import { render, staticRenderFns } from "./MessageProcess.vue?vue&type=template&id=4a9d64de&scoped=true"
import script from "./MessageProcess.vue?vue&type=script&lang=js"
export * from "./MessageProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d64de",
  null
  
)

export default component.exports